import React from 'react';
import { useNavigate } from 'react-router-dom';
import Reveal from './Reveal';
import StoreButtons from './StoreButtons';
import { usePressSpring } from '../hooks/usePressSpring';
import { useLanguage } from '../i18n/LanguageContext';
import { cx } from '../utils/cx';
import styles from './AppCard.module.css';

// "Today" tab style card: full-bleed art background, big headline, and a
// floating glass info bar — ported from the today-card.html reference.
export default function AppCard({ app, delay = 0 }) {
  const { L } = useLanguage();
  const navigate = useNavigate();
  const pressRef = usePressSpring(styles.pressed);

  const go = () => navigate(`/app/${app.id}`);

  return (
    <Reveal delay={delay}>
      <article
        ref={pressRef}
        className={styles.card}
        role="link"
        tabIndex={0}
        aria-label={app.name}
        onClick={go}
        style={!app.art ? { '--card-tint': app.tint } : undefined}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            go();
          }
        }}
      >
        {app.art ? (
          <picture className={styles.art}>
            <source media="(max-width: 700px)" srcSet={app.art.mobileWebp || app.art.mobile} type={app.art.mobileWebp ? 'image/webp' : undefined} />
            {app.art.mobileWebp && <source media="(max-width: 700px)" srcSet={app.art.mobile} />}
            {app.art.desktopWebp && <source srcSet={app.art.desktopWebp} type="image/webp" />}
            <img className={styles.artImg} src={app.art.desktop} alt="" loading="lazy" />
          </picture>
        ) : (
          <div className={cx(styles.art, styles.artFallback)} />
        )}

        <div className={styles.head}>
          <div className={styles.eyebrow}>{L(app.category)}</div>
          <h3 className={styles.title}>{L(app.headline)}</h3>
        </div>

        <div className={cx(styles.bar)}>
          <div className={styles.icon}>
            {app.icon ? <img src={app.icon} alt={app.name} loading="lazy" /> : null}
          </div>
          <div className={styles.info}>
            <span className={styles.name}>{app.name}</span>
            <span className={styles.sub}>{L(app.subtitle)}</span>
          </div>
          <div className={styles.stores}>
            <StoreButtons app={app} compact />
          </div>
        </div>
      </article>
    </Reveal>
  );
}
